import { render } from "./SchoolsColleges.vue?vue&type=template&id=eff6cd64"
import script from "./SchoolsColleges.vue?vue&type=script&lang=js"
export * from "./SchoolsColleges.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src218436265/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__